import gql from 'not-graphql-tag';

export const getAccountDetailsQuery = gql`
  query getAccountDetails($params: AccountDetailParams!) {
    getAccountDetails(params: $params) {
      accountNumber
      encryptedAccountNumber
      encryptedPersonId
      description
      isDefault
      accountType
      relationType
      mainCustomerName
      premiseInfo {
        addressLine1
        city
        state
        postal
      }
      isActive
      renewableEnrollment {
        renewableEnrollmentStatus
      }
    }
  }
`;

export const renewablesAccountEligibilityQuery = gql`
  query renewablesAccountEligibility(
    $payload: RenewablesAccountEligibleRequest
  ) {
    renewablesAccountEligibility(payload: $payload) {
      isIndustrial
      isSmallBusiness
      eligibility
      encryptedServiceAgreementId
    }
  }
`;

export const getRenewablesQuery = gql`
  query getRenewables($payload: RenewableInput!) {
    getRenewables(payload: $payload) {
      isGreenSourceEnrolled
			isCleanWindEnrolled
			cleanWindBlocks
			isHabitatSupportEnrolled
			isGreenFutureSolarEnrolled
			greenFutureSolarBlocks
    }
  }
`;

export const updateRenewablesMutation = gql`
  mutation updateRenewables($payload: RenewablePowerInput) {
    updateRenewables(payload: $payload)
  }
`;

export const createRenewablesEnrollmentTodoMutation = gql`
  mutation createRenewablesEnrollmentTodo(
    $payload: RenewablesEnrollmentToDoRequest
  ) {
    createRenewablesEnrollmentTodo(payload: $payload)
  }
`;

